var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1 10.2271C20.1 9.518 20.0364 8.83619 19.9182 8.18164H10.5V12.0498H15.8818C15.65 13.2998 14.9455 14.3589 13.8864 15.068V17.5771H17.1182C19.0091 15.8362 20.1 13.2725 20.1 10.2271Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 19.9999C13.2001 19.9999 15.4637 19.1044 17.1183 17.5772L13.8864 15.0681C12.991 15.6681 11.8455 16.0226 10.5001 16.0226C7.89554 16.0226 5.69099 14.2635 4.90463 11.8999H1.56372V14.4908C3.20918 17.759 6.59099 19.9999 10.5001 19.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90455 11.9002C4.70455 11.3002 4.59091 10.6593 4.59091 10.0002C4.59091 9.3411 4.70455 8.70019 4.90455 8.10019V5.50928H1.56364C0.886364 6.85928 0.5 8.38655 0.5 10.0002C0.5 11.6138 0.886364 13.1411 1.56364 14.4911L4.90455 11.9002Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 3.97727C11.9683 3.97727 13.2864 4.48182 14.3228 5.47273L17.191 2.60455C15.4592 0.990909 13.1955 0 10.5001 0C6.59099 0 3.20918 2.24091 1.56372 5.50909L4.90463 8.1C5.69099 5.73636 7.89554 3.97727 10.5001 3.97727Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.e887a3e9f4ea8d1eb3dbf14c7316ff6b.svg";
export { ForwardRef as ReactComponent };